
import { get, responseResult } from './api';
/**
 * 
 * @param {*} filters 
 * @returns 
 */
export const getFutureTransaction = (filters) => get('future_transactions', filters).then(responseResult)
